import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { useMemberProducts } from "@nju/data-access-portal-product";
import { SidebarInternational } from "@nju/feature-portal-sidebar";
import { portalRoutes } from "@nju/routes";
import { BlockContent, CircleLoader, Layout, Main, Side } from "@nju/ui";
import { internationalSummaryMachine } from "./internationalSummaryPage.machine";
import { PaymentError, Success, Summary } from "./partials";

export function InternationalSummaryPage() {
  const router = useRouter();
  const { zone, country, userId, zoneName } =
    portalRoutes.mojeKonto.uslugiDodatkowe.rozmowyMiedzynarodowe.podsumowanie
      .input(router.query)
      .unwrap();
  const memberProducts = useMemberProducts();

  const [current, send] = useMachine(internationalSummaryMachine, {
    context: {
      zone,
      country,
      userId,
      subId: memberProducts.mobileProducts.mobileAccess?.id,
    },
  });

  const { context, matches } = current;
  const {
    anniversaryDate,
    productOfferGrantValue,
    productOfferPrice,
    userFunds,
  } = context;

  const addAdditionalPackage = React.useCallback(() => {
    send({
      type: "ADD_PACKAGE",
    });
  }, [send]);

  if (matches("loading")) {
    return (
      <div className="flex justify-center items-center h-full">
        <CircleLoader />
      </div>
    );
  }

  if (matches("success")) {
    return <Success userId={userId} />;
  }

  if (matches("error")) {
    return <PaymentError />;
  }

  return (
    <BlockContent spacingRow="none">
      <Layout>
        <Main>
          {matches("ready") && (
            <Summary
              addAdditionalPackage={addAdditionalPackage}
              country={country}
              hasNoFunds={matches({ ready: "noFunds" })}
              hasOrderInProgress={matches({ ready: "orderInProgress" })}
              isBuying={matches({ ready: "buying" })}
              isReady={matches({ ready: "init" })}
              productOfferGrantValue={productOfferGrantValue}
              productOfferPrice={productOfferPrice}
              userId={userId}
              zone={zone}
              zoneName={zoneName}
            />
          )}
        </Main>
        <Side>
          {!matches({ ready: "orderInProgress" }) && (
            <SidebarInternational
              anniversaryDate={anniversaryDate}
              hasNoFunds={matches({ ready: "noFunds" })}
              productOfferPrice={productOfferPrice}
              userFunds={userFunds}
            />
          )}
        </Side>
      </Layout>
    </BlockContent>
  );
}
